import { useEffect } from "react";
import { useGetApi } from "src/hooks";
import { getIds } from "src/pages/Home/Home.utils";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setManagementLinks } from "src/redux/slices/permsSlice";
/**
 * Custom hook to manage and fetch management links based on user permissions.
 *
 * @param fetchLinks - A boolean indicating whether to fetch management links on initialization.
 * @returns An object containing:
 * - `isAuthorizedToSeeLinks`: A boolean indicating if the user has permission to see management links.
 * - `managementLinks`: An array of management link IDs.
 */
const useManagementLinks = (fetchLinks?: boolean) => {
  const dispatch = useDispatch();
  const { managementLinks, management, clientAdmin } = useSelector(
    state => state.permsSlice,
  );
  const { data, refetch } = useGetApi({
    request: "get-home",
    fetchOnInit: false,
  });

  useEffect(() => {
    if (
      fetchLinks &&
      (!managementLinks || managementLinks.length === 0) &&
      (management || clientAdmin)
    ) {
      void refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [fetchLinks, managementLinks, management, clientAdmin]);

  useEffect(() => {
    if (!data) return;
    const ids = getIds(data);
    if (ids) dispatch(setManagementLinks(ids));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [data]);

  return { isAuthorizedToSeeLinks: management || clientAdmin, managementLinks };
};
export default useManagementLinks;
